import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {map, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class EventAccessService {

  baseURL = environment.baseUrl + 'event-request';

  constructor(private http: HttpClient) {
  }



  getAllEventAccess(eventId:any,page: number, size: number, keyWord:any): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/event/${eventId}`,{
      params:new HttpParams()
        .append('page',page)
        .append('size',size)
        .append('keyWord',keyWord)
    })
  }

  updateStatus(eventId:number, check:boolean,userId:number,accessId:number): Observable<any> {
    const params = new HttpParams()
      .set('userId',userId)
      .set('accessId', accessId)
    return this.http.put<any>(`${this.baseURL}/event/${eventId}/status/${check}`, {}, { params }).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  exportExcel(eventId:any){
    return this.http.get(`${this.baseURL}/excel/event/${eventId}`, {
      responseType: 'blob'
    });
  }

}
